'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _sharedSliderJacketCover = require('@bibliocommons/shared-slider-jacket-cover');

var _sharedSliderJacketCover2 = _interopRequireDefault(_sharedSliderJacketCover);

var _rating = require('@bibliocommons/rating');

var _rating2 = _interopRequireDefault(_rating);

var _baseCard = require('@bibliocommons/base-card');

var _reactIntl = require('react-intl');

require('../styles/RatingCard.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RatingCard = function RatingCard(_ref) {
  var className = _ref.className,
      item = _ref.item,
      rating = _ref.rating,
      creator = _ref.creator,
      border = _ref.border;

  var creatorUrl = '/user_profile/' + creator.id;
  var renderProp = function renderProp(sectionClass) {
    return _react2.default.createElement(
      'div',
      { className: sectionClass },
      _react2.default.createElement(_rating2.default, { readOnly: true, rating: rating.rating, id: item.id, metadataId: item.id, type: 'average' }),
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'by_authors', values: { authorLinks: _react2.default.createElement(
            'a',
            { className: 'author-links', href: creatorUrl },
            creator.name
          ) } })
    );
  };

  var cardClass = 'cp-rating-card ' + className;
  return _react2.default.createElement(
    _baseCard.CardWrapper,
    { border: border, className: cardClass },
    _react2.default.createElement(_sharedSliderJacketCover2.default, { item: item }),
    _react2.default.createElement(_baseCard.CardSection, { className: 'rating-body', renderProp: renderProp })
  );
};

RatingCard.propTypes = {
  className: _react.PropTypes.string,
  border: _react.PropTypes.bool,
  item: _react.PropTypes.shape({
    id: _react.PropTypes.string.isRequired,
    format: _react.PropTypes.string.required,
    jacket: _react.PropTypes.shape({
      medium: _react.PropTypes.string.isRequired
    }).isRequired,
    title: _react.PropTypes.string.required
  }).isRequired,
  creator: _react.PropTypes.shape({ id: _react.PropTypes.string, name: _react.PropTypes.string }).isRequired,
  rating: _react.PropTypes.shape({
    rating: _react.PropTypes.number.isRequired, // integer 0 - 100
    id: _react.PropTypes.string.isRequired,
    type: _react.PropTypes.string.isRequired,
    readOnly: _react.PropTypes.bool,
    metadataId: _react.PropTypes.string
  }).isRequired
};

RatingCard.defaultProps = {
  border: false,
  rating: {
    readOnly: true,
    type: 'average'
  }
};

exports.default = RatingCard;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/card/rating-card/lib/components/RatingCard.component.js
// module id = 989
// module chunks = 9